import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/Components/ScrollToTop/ScrollToTop ";
import Inicio from "@/Page/Inicio";
import Details from "@/Page/DetailsKNowMore/Details";
import ListOfCategorys from "@/Page/ListCategories/ListOfCategorys";
import PlpArticles from "@/Page/Plp/PlpArticles";
import PdpArticles from "@/Page/Pdp/PdpArticles";
import CheckoutArticles from "@/Page/Checkout/CheckoutArticles";
import PagePLP from "@/Page/Plp/PagePLP";
//import ContextMovilCategorieProvider from "@/Context/Categorie/ContextMovilCategories";
import ContextCategorieProvider from "@/Context/Categorie/ContextCategorieProvider";
import ListOfCategorysV2 from "@/Page/ListCategories/ListOfCategorysV2";
import PagePDP from "@/Page/Pdp/PagePDP";
import { ContextProductProvider } from "@/Context/Product/ContextProductProvider";
import PageCheckout from "@/Page/Checkout/PageCheckout";
import PageFinishBuy from "@/Page/Checkout/FinishBuy/PageFinishBuy";
import PagePrintTicket from "@/Page/PrinctTicket/PagePrintTicket";
import PageLogin from "@/Page/Login/PageLogin";

const RouterNavigate = () => {
  return (
    <Router
      future={{
        v7_relativeSplatPath: true,
      }}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/:conocer" element={<Details />} />
        <Route path="/Electrónica" element={<ListOfCategorys />} />
        <Route path="/Electrónicav2" element={<ListOfCategorysV2 />} />
        <Route
          path="/Electrónica/:cteg/:subcateg"
          element={
            <ContextCategorieProvider>
              <PlpArticles />
            </ContextCategorieProvider>
          }
        />
        <Route
          path="/Electrónicav2/:cteg/:subcateg"
          element={
            <ContextCategorieProvider>
              {/* <ContextMovilCategorieProvider> */}
              <PagePLP />
              {/* </ContextMovilCategorieProvider> */}
            </ContextCategorieProvider>
          }
        />
        <Route
          path="/Electrónica/:cteg/:subcateg/article/storeId/:id/c"
          element={<PdpArticles />}
        />
        <Route
          path="/Electrónicav2/:cteg/:subcateg/article/storeId/:id/c"
          element={
            <ContextProductProvider>
              <PagePDP />
            </ContextProductProvider>
          }
        />
        <Route
          path="/Electrónica/:cteg/:subcateg/checkout/storeId/buy/:id/c/n/:names/cant/:quant"
          element={<CheckoutArticles />}
        />
        <Route
          path="/Electrónicav2/articles/c/Checkout/Buy"
          element={
            <ContextProductProvider>
              <PageCheckout />
            </ContextProductProvider>
          }
        />
        <Route
          path="/Electrónicav2/articles/c/Checkout/FinshBuy"
          element={
            <ContextProductProvider>
              <PageFinishBuy />
            </ContextProductProvider>
          }
        />
        <Route
          path="/Electrónicav2/login/c/Checkout/ticketPrint"
          element={<PagePrintTicket />}
        />
        <Route path="/Electrónicav2/c/login" element={<PageLogin />} />
      </Routes>
    </Router>
  );
};

export default RouterNavigate;
